<script>
export default {
  data() {
    return {
      loading: false,
      show_search: false,
      initial: true,
      keywords: '',
      results: {
        reports: [],
        posts: []
      }
    }
  },
  mounted() {
    
  },
  methods: {
    fetchSearch() {
      if(this.keywords.length < 3) return;
      axios.get('/search', {
          params: { 'keyword' : this.keywords}
      })
      .then((response) => {
        this.initial = false;
        this.results.reports = response.data.reports;
        this.results.posts = response.data.posts;
        this.$nextTick(() => {
          this.loading = false;
        });
      })
      .catch((error) => {
        this.loading = false;
          console.log(error);
      });
    },
  }
}
</script>